type CallbackParams = { code: string | null; state: string | null };

let _urlCallbackParams: CallbackParams | null = null;

export function stripCallbackUrl(): void {
  if (!window.location.search.includes('code=')) return;
  const url = new URL(window.location.href);
  _urlCallbackParams = {
    code: url.searchParams.get('code'),
    state: url.searchParams.get('state'),
  };
  url.searchParams.delete('code');
  url.searchParams.delete('state');
  window.history.replaceState({}, '', url.toString());
}

export function consumeCallbackParams(): CallbackParams | null {
  const callbackParams = _urlCallbackParams;
  _urlCallbackParams = null;
  return callbackParams;
}
